'use client'

import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { useEffect } from 'react'
import { useCurrentUser } from '@/hooks/use-current-user'

export function PushNotificationsHandler() {
  const { data: user } = useCurrentUser()

  useEffect(() => {
    const registerPushNotifications = async () => {
      if (!Capacitor.isNativePlatform()) return

      try {
        let permStatus = await PushNotifications.checkPermissions()

        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions()
        }

        if (permStatus.receive !== 'granted') {
          return
        }

        await PushNotifications.register()

        PushNotifications.addListener('registration', async (token) => {
          console.log('Push registration success, token: ' + token.value)
          if (user?._id) {
            await sendTokenToBackend(token.value)
          } else {
            // Store token temporarily if user is not logged in, to send later?
            // Or just rely on the fact that this component re-renders/effect runs when user logs in.
            // Storing in local storage might be safer.
            localStorage.setItem('temp_push_token', token.value)
          }
        })

        PushNotifications.addListener('registrationError', (error) => {
          console.error('Error on registration: ' + JSON.stringify(error))
        })
      } catch (e) {
        console.error('Error registering push notifications:', e)
      }
    }

    registerPushNotifications()
  }, [user?._id]) // Re-run when user logs in

  // Effect to handle sending stored token after login
  useEffect(() => {
    const sendStoredToken = async () => {
      if (user?._id) {
        const storedToken = localStorage.getItem('temp_push_token')
        if (storedToken) {
          await sendTokenToBackend(storedToken)
          localStorage.removeItem('temp_push_token')
        }
      }
    }
    sendStoredToken()
  }, [user?._id])

  const sendTokenToBackend = async (token: string) => {
    try {
      await fetch('/api/me/devices', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
          platform: Capacitor.getPlatform(),
        }),
      })
    } catch (e) {
      console.error('Error sending push token to backend:', e)
    }
  }

  return null
}
